import type { MetricKey } from './model';

export type MetricColumn = { key: MetricKey; label: string; format?: 'percent' | 'decimal' };

export const metricColumns: Array<MetricColumn> = [
  { key: 'sales', label: 'Sales AUD' },
  { key: 'margin', label: 'Margin AUD' },
  { key: 'marginRate', label: '% Margin (adj)', format: 'percent' },
  { key: 'totalMargin', label: 'Total margin AUD' },
  { key: 'totalMarginRate', label: 'Total margin %', format: 'percent' },
  { key: 'packages', label: 'Packages' },
  { key: 'orders', label: 'Orders' },
  { key: 'nights', label: 'Room nights' },
  { key: 'adr', label: 'ADR (Vendor)' },
  { key: 'leadTime', label: 'Avg lead time' },
  { key: 'los', label: 'Avg LOS', format: 'decimal' },
  { key: 'adults', label: 'No. Adults' },
  { key: 'children', label: 'No. Children' },
  { key: 'infants', label: 'No. Infants' },
];

export function columnsFor(keys: Array<MetricKey>): Array<MetricColumn> {
  return keys.flatMap((key) => {
    const column = metricColumns.find((item) => item.key === key);
    return column ? [column] : [];
  });
}

export function metricText(value: number | null | undefined, format?: MetricColumn['format']): string {
  if (value === null || value === undefined || !Number.isFinite(value)) {
    return 'Unknown';
  }
  return new Intl.NumberFormat(
    'en-AU',
    format === 'percent'
      ? { style: 'percent', minimumFractionDigits: 1, maximumFractionDigits: 1 }
      : { minimumFractionDigits: format === 'decimal' ? 2 : 0, maximumFractionDigits: format === 'decimal' ? 2 : 0 },
  ).format(value);
}
